import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  BudgetBudgetHistoryMatchParams,
  budgetHistoryRouteProps,
} from 'src/navigation/routeProps'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<BudgetBudgetHistoryMatchParams>(
      backgroundLocation.pathname,
      budgetHistoryRouteProps,
    ) as match<BudgetBudgetHistoryMatchParams>
    return mtch.params.id
  },
)
